import API from "@/API";

export default {
  data() {
    return {
      dataTargetBookGroups: [],
      mixinTargetTicket: [],
      data: null,
      passIds: [],
      masterPassID: null,
      sheetIds: [],
      masterSheetID: null,
    };
  },

  methods: {
    // fnc=MTKで読まれたQR文字列に対応したBookGroupを割り出し返却する関数
    async arrangeBookGroup() {
      // QRコード文字列を取得

      // BFFへ読み込んだQR文字列をリクエストに含めてコールすると対応したBookGroupのデータを返してくれる
      this.data = await this.postQRCodeSupport();

      // 持ってる該当Myチケットが0 / 1 / 1以上 で処理
      // book_groups.length == 0 の場合: 該当チケットなしなので、master_book_idを参照の上、チケット詳細画面へ
      // book_groups.length == 1 の場合: 該当Myチケット1個なので、Myチケットの画面に遷移してください。
      // book_groups.length > 1 の場合: 該当Myチケット複数ありなので、Myチケットを選択画面を表示してください。

      console.log(
        "arrangeBookGroup this.data.book_groups :>> ",
        this.data.book_groups
      );
      if (this.data.book_groups.length == 0) {
        console.log("該当パス/シートがなし ");
        this.goToBooks(this.$route.query.master_book_id);
      } else if (this.data.book_groups.length == 1) {
        console.log("該当パス/シートが１枚");
        this.oneBookGroupIsWorth();
      } else {
        console.log("該当パス/シートが複数枚");
        this.multipleBookGroupsAreWorth();
        return {
          targetBookGroups: this.dataTargetBookGroups,
          targetTickets: this.mixinTargetTicket,
        };
      }
    },

    // BFFへ読み込んだQR文字列をリクエストに含めてコールすると対応したBookGroupのデータを返してくれる
    async postQRCodeSupport() {
      var apiParams = {
        qr_message: `${this.$route.fullPath.split("?")[1]}`,
      };
      return await API.postQRCodeSupport(apiParams);
    },
    // book_groups.length == 1 の場合: 該当Myチケット1個なので、Myチケットの画面に遷移してください。
    // しかしその中でも使える券面がなければストアへリダイレクトすること
    oneBookGroupIsWorth() {
      this.dataTargetBookGroups.push(this.data.book_groups[0]);

      // パス/シートそれぞれ処理
      if (this.dataTargetBookGroups[0]._qrcode_mtk_type == "pass") {
        console.log("パス");
        this.arrangePass();

        // 該当するパスがない場合はブックストア・１枚ある場合はパス券面へ
        this.redirectCorrectPagePass();
      } else if (this.dataTargetBookGroups[0]._qrcode_mtk_type == "sheet") {
        console.log("シート");
        this.arrangeOneSheet();
        // 該当するシートがない場合はブックストア・１枚ある場合はシート券面へ行き、有効化
        this.redirectCorrectPageSheet();
      }
    },
    arrangePass() {
      var that = this;
      this.dataTargetBookGroups[0].books[0].passes.forEach(function (
        targetPassEach
      ) {
        that.dataTargetBookGroups[0]._qrcode_master_pass_id
          .split(",")
          .forEach(function (pass_id) {
            if (
              pass_id == targetPassEach.master_pass_id &&
              !targetPassEach.is_valid
            ) {
              that.passIds.push(targetPassEach.id);
              that.masterPassID = targetPassEach.master_pass_id;
            }
          });
      });
    },
    arrangeOneSheet() {
      var that = this;
      // 該当ブックグループが１枚なので、dataTargetBookGroupsの先頭のbookのもつシートをループ
      this.dataTargetBookGroups[0].books[0].sheets.forEach(function (
        targetSheetEach
      ) {
        console.log("targetSheetEach :>> ", targetSheetEach);
        // 読み取ったQRに乗ってるmaster_sheet_idと同義である_qrcode_master_sheet_idの配列をループして該当シートを持っているかをリサーチする
        that.dataTargetBookGroups[0]._qrcode_master_sheet_id
          .split(",")
          .forEach(function (sheet_id) {
            console.log("sheet_id :>> ", sheet_id);
            // 以下の条件に当てはまればdataへpush
            // 1,シートID = ターゲットIDかつシートが未使用かつループ制御フラグがfalse
            if (
              sheet_id == targetSheetEach.master_sheet_id &&
              !targetSheetEach.is_used
            ) {
              that.sheetIds.push(targetSheetEach.id);
              that.masterSheetID = targetSheetEach.master_sheet_id;
            }
          });
      });
    },
    // book_groups.length > 1 の場合: 該当Myチケット複数ありなので、Myチケットから使う券面を選択する画面を表示してください。
    multipleBookGroupsAreWorth() {
      if (this.data.book_groups[0]._qrcode_mtk_type == "pass") {
        console.log("パス複数");
        this.arrangePasses();

        // 該当するパスがない場合はブックストア・１枚ある場合はパス券面へ
        this.redirectCorrectPagePass();
      } else if (this.data.book_groups[0]._qrcode_mtk_type == "sheet") {
        console.log("object :>> シート複数");
        this.arrangeMultiSheets();

        // 該当するシートがない場合はブックストア・１枚ある場合はシート券面へ行き、有効化
        this.redirectCorrectPageSheet();
      }
    },
    arrangePasses() {
      var that = this;
      // 該当BooGroupが複数枚なのでdataTargetBookGroupsをループ
      this.data.book_groups.forEach(function (bookGroup) {
        bookGroup.books[0].passes.forEach(function (targetPassEach) {
          bookGroup._qrcode_master_pass_id
            .split(",")
            .forEach(function (pass_id) {
              if (pass_id == targetPassEach.master_pass_id) {
                var start;
                var limit;
                if (bookGroup.books[0].user_started_at) {
                  start = bookGroup.books[0].user_started_at;
                  limit = bookGroup.books[0].user_limited_at;
                } else {
                  start = bookGroup.books[0].available_started_at;
                  limit = bookGroup.books[0].available_limited_at;
                }

                that.mixinTargetTicket.push({
                  name: targetPassEach.name,
                  id: targetPassEach.id,
                  label: bookGroup.divisions_label,
                  start: start,
                  limit: limit,
                  is_used: targetPassEach.is_valid,
                  master_id: targetPassEach.master_pass_id,
                });
                // 利用可能なパスのIDを集める
                if (!targetPassEach.is_valid) {
                  that.dataTargetBookGroups.push(bookGroup);
                  that.passIds.push(targetPassEach.id);
                }
              }
            });
        });
      });
    },
    arrangeMultiSheets() {
      var that = this;
      console.log("this.dataTargetBookGroups :>> ", this.dataTargetBookGroups);

      // 該当BooGroupが複数枚なのでdataTargetBookGroupsをループ
      this.data.book_groups.forEach(function (bookGroup) {
        // 単純に下でループするブックが持つシートの数
        var countCheckSheets = bookGroup.books[0].sheets.length - 1;

        // APIから帰ってきた該当するbook_groups(this.dataTargetBookGroups)をループしてそれに紐づいたbooksをループしてそれに紐づいたシートを総なめする
        for (let [
          s_index,
          targetSheetEach,
        ] of bookGroup.books[0].sheets.entries()) {
          // ループ制御フラグ
          // false であるということはこのループ内で一度もmixinTargetTicketに
          var flag = false;

          // ループで調べるべきMasterSheetの数
          var countMSI =
            bookGroup._qrcode_master_sheet_id.split(",").length - 1;

          // 読み取ったQRに乗ってるmaster_sheet_idと同義である_qrcode_master_sheet_idの配列をループして該当シートを持っているかをリサーチする
          bookGroup._qrcode_master_sheet_id
            .split(",")
            .forEach(function (sheet_id, index) {
              // 以下の条件に当てはまればdataへpush
              // 1,シートID = ターゲットIDかつシートが未使用かつループ制御フラグがfalse
              // 2,1の条件に当て当てはまらず、ループすべき最後のシートにきてしまった場合(つまり未使用として指定したいシートがなく、使用済みのシートを仕方なくpushする場合)
              // countMSI == index → 調べるべき_qrcode_master_sheet_idが最後であることを表す
              // countCheckSheets == s_index → 調べるべきdataTargetBookGroupsのbookのもつシートが最後であることを表す
              if (
                (sheet_id == targetSheetEach.master_sheet_id &&
                  !targetSheetEach.is_used &&
                  !flag) ||
                (countMSI == index && countCheckSheets == s_index && !flag)
              ) {
                // that.mixinTargetTicketには、画面表示に必要なため2の条件を通って!is_usedもpushされることもあるため
                // ここでさらに単体の条件で分岐にかけて利用可能なシートのIDを集める
                if (!targetSheetEach.is_used) {
                  var start;
                  var limit;
                  if (bookGroup.books[0].user_started_at) {
                    start = bookGroup.books[0].user_started_at;
                    limit = bookGroup.books[0].user_limited_at;
                  } else {
                    start = bookGroup.books[0].available_started_at;
                    limit = bookGroup.books[0].available_limited_at;
                  }

                  that.mixinTargetTicket.push({
                    name: targetSheetEach.name,
                    id: targetSheetEach.id,
                    label: bookGroup.divisions_label,
                    start: start,
                    limit: limit,
                    is_used: targetSheetEach.is_used,
                    master_id: targetSheetEach.master_sheet_id,
                  });

                  that.dataTargetBookGroups.push(bookGroup);
                  that.masterSheetID = targetSheetEach.master_sheet_id;
                  that.sheetIds.push(targetSheetEach.id);
                }
                flag = true;
              }
            });

          // 必要なシート情報が入れられたと判断できるのでbreakして次のbookgroupへ
          if (flag) {
            break;
          }
        }
      });
    },

    redirectCorrectPagePass() {
      console.log("redirectCorrectPagePass this.passIds :>> ", this.passIds);
      if (this.passIds.length == 0) {
        this.goToBooks(this.$route.query.master_book_id);
      } else if (this.passIds.length == 1) {
        console.log(
          "this.dataTargetBookGroups[0] :>> ",
          this.dataTargetBookGroups[0]
        );
        this.gotoPass(
          this.dataTargetBookGroups[0],
          this.masterPassID,
          this.passIds
        );
      }
    },
    redirectCorrectPageSheet() {
      console.log("dataTargetBookGroups[0] :>> ", this.dataTargetBookGroups[0]);
      console.log("masterSheetID :>> ", this.masterSheetID);
      console.log("redirectCorrectPageSheet this.sheetIds :>> ", this.sheetIds);
      console.log(
        'this.$route.fullPath.split("?")[1] :>> ',
        this.$route.fullPath.split("?")[1]
      );
      if (this.sheetIds.length == 0) {
        this.goToBooks(this.$route.query.master_book_id);
      } else {
        this.gotoSheetValid(
          this.dataTargetBookGroups[0],
          this.masterSheetID,
          this.sheetIds,
          this.$route.fullPath.split("?")[1]
        );
      }
    },
    goToBooks(id) {
      if (this.ENV === "local") {
        this.$router.push({
          name: "MasterBook",
          params: { id: id },
          query: {
            fromQR: true,
            language: this.$store.getters["common/lang"],
          },
        });
      } else {
        this.openTicket(
          `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}ticket-store/ticketing/master-book/${id}?fromQR=true`
        );
      }
    },
    gotoPass(BookGroup, masterPassID, passIds) {
      console.log("passIds :>> " + passIds);
      if (this.ENV === "local") {
        window.location.href = `http://${window.location.host}/#/my-tickets/ticketing/${BookGroup.id}/master-pass/${masterPassID}/pass/${passIds}?fromQR=true`;
      } else {
        this.openTicket(
          `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}my-tickets/ticketing/${BookGroup.id}/master-pass/${masterPassID}/pass/${passIds}?fromQR=true`
        );
      }
    },

    gotoSheetValid(BookGroup, masterSheetID, sheetIds, qrCode) {
      console.log("BookGroup :>> " + BookGroup);
      console.log("masterSheetID :>> " + masterSheetID);
      console.log("sheetIds :>> " + sheetIds);
      console.log("qrCode :>> ", qrCode);
      if (this.ENV === "local") {
        window.location.href = `http://${window.location.host}/#/my-tickets/ticketing/${BookGroup.id}/master-sheet/${masterSheetID}/sheet/${sheetIds}?fromQR=true&${qrCode}`;
      } else {
        this.openTicket(
          `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}my-tickets/ticketing/${BookGroup.id}/master-sheet/${masterSheetID}/sheet/${sheetIds}?fromQR=true&${qrCode}`
        );
      }
    },
  },
};
